import * as React from "react";
import { useTranslation } from "react-i18next";

import { SpecialBettingsColorEnum } from "../../enums";

interface Props {
  color: string;
}

const ColorBetting: React.FC<Props> = ({ color }) => {
  const { t } = useTranslation();

  return (
    <div className="diamond_shape">
      <div
        className={`diamond ${
          color === SpecialBettingsColorEnum.RED ? "red" : "black"
        }`}
      />
      <div className="sign">
        {color.includes(SpecialBettingsColorEnum.RED)
          ? t("panel.bettingPanel.red")
          : t("panel.bettingPanel.black")}
      </div>
    </div>
  );
};

export default ColorBetting;
